import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, catchError, map, throwError} from 'rxjs';
import {PagamentoCreditoVM} from 'src/app/api/model/conta/pagamento/pagamentoVM';
import {AppConfigurationService} from '../../../erp/services/base/appConfiguration.service';

@Injectable({
  providedIn: 'root',
})
export class PagamentopPropostaService {
  constructor(
    private httpClient: HttpClient,
    private appConfigurationService: AppConfigurationService,
  ) {}

  gerarBoleto(propostaId: string): Observable<Number> {
    const url = `${this.appConfigurationService.apiBaseUrl}/payment/Boleto/${propostaId}`;
    return this.httpClient.post<Number>(url, {}).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  credito(pagamentocartaoCredito: PagamentoCreditoVM): Observable<Number> {
    const url = `${this.appConfigurationService.apiBaseUrl}/payment/pagbank/creditcard/${pagamentocartaoCredito.propostaId}`;
    return this.httpClient.post<Number>(url, pagamentocartaoCredito).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  colaboradorConfirmarPagamento(propostaId: string, contractCollectiveMembershipId: string): Observable<Number> {
    const url = `${this.appConfigurationService.apiBaseUrl}/payment/PaymentConfirm?proposalId=${propostaId}&contractCollectiveMembershipId=${contractCollectiveMembershipId}`;
    return this.httpClient.post<Number>(url, {}).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  buscarDadosPagamentoPorProposta(propostaId: any): Observable<any> {
    const url = `${this.appConfigurationService.apiBaseUrl}/payment/MembershipFee/GetByProposalIdAsync/${propostaId}`;
    return this.httpClient.get<any>(url).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  listaParcelasCartao(propostaId: any): Observable<any> {
    const url = `${this.appConfigurationService.apiBaseUrl}/payment/pagbank/installment/${propostaId}`;
    return this.httpClient.get<any>(url).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  listarChavePagBank(): Observable<any> {
    const url = `${this.appConfigurationService.apiBaseUrl}/payment/pagbank/public-key`;
    return this.httpClient.get<any>(url).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  enviarComprovanteBancarioBeneficiario(documentoVM: any, arquivo: any): Observable<Number> {
    const formData = new FormData();
    formData.append('file', arquivo);

    let url = `${this.appConfigurationService.apiBaseUrl}/payment/UploadProofPayment?proposalId=${documentoVM.proposalId}`;

    if (documentoVM?.paymentMethodEnum) {
      url += `&paymentMethodEnum=${documentoVM?.paymentMethodEnum}`;
    }

    return this.httpClient.post<Number>(url, formData).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  atualizarDadosPagamentoColaborador(pagmentoVM: any): Observable<Number> {
    return this.httpClient
      .put<Number>(`${this.appConfigurationService.apiBaseUrl}/payment/UpdateMembershipFee`, pagmentoVM)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }
}
